import { ESerpTypes } from "app/common/serp/SerpFilterMaps";

/** Omitted/null excluded list matches edit-campaign default: Ads (paid) excluded. */
export const isPaidExcludedFromPosition = (positionExcludedSerpFeatures?: readonly ESerpTypes[] | null): boolean =>
    (positionExcludedSerpFeatures ?? [ESerpTypes.paid]).includes(ESerpTypes.paid);
